import { defineComponent as _defineComponent } from 'vue'
import { QButton } from '../../../shared';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddNewCategoryButton',
  setup(__props) {

  
return { __sfc: true,QButton }
}

})